import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Radio } from "components/common";
import { strategiesLabels } from "views/logic/valueactions/createEventDefinition/Constants";
const Container = styled.div`
  display: flex;
  gap: 5px;
  align-items: baseline;
`;
const RadioSection = ({ strategy, onChange, strategyAvailabilities }) => {
  const { t } = useTranslation("search");
  const { description } = strategiesLabels[strategy];
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("b", null, t("create_event_definition.strategy_by")), /* @__PURE__ */ React.createElement(Container, null, Object.entries(strategiesLabels).map(([curStrategy, { label }]) => {
    if (!strategyAvailabilities[curStrategy]) return null;
    return /* @__PURE__ */ React.createElement(
      Radio,
      {
        id: curStrategy,
        key: curStrategy,
        name: "strategy",
        value: curStrategy,
        checked: curStrategy === strategy,
        onChange
      },
      t(label)
    );
  })), /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement("b", null, t("create_event_definition.description"), " "), /* @__PURE__ */ React.createElement("i", null, t(description))));
};
export default RadioSection;
